import { render, staticRenderFns } from "./CIV.vue?vue&type=template&id=4adf822c&scoped=true&"
import script from "./CIV.vue?vue&type=script&lang=js&"
export * from "./CIV.vue?vue&type=script&lang=js&"
import style0 from "./CIV.vue?vue&type=style&index=0&id=4adf822c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf822c",
  null
  
)

export default component.exports